import {
  GET_DECLINE_REASON_REQ,
  GET_DECLINE_REASON_FAIL,
  GET_DECLINE_REASON_SUCCESS,
  SAVE_DECLINE_REASON_REQ,
  SAVE_DECLINE_REASON_SUCCESS,
  SAVE_DECLINE_REASON_FAIL,
} from "../constants/declineReason";

import { toast } from "react-toastify";

import api from "../../services/api";

export const getDeclineReasons = () => async (dispatch, getState) => {
  try {
    dispatch({ type: GET_DECLINE_REASON_REQ });
    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.gmBackendToken}`,
      },
    };

    const { data } = await api.get(`/api/decline-reasons`, config);
    dispatch({
      type: GET_DECLINE_REASON_SUCCESS,
      payload: data?.body,
    });
  } catch (error) {
    dispatch({
      type: GET_DECLINE_REASON_FAIL,
      payload: error.message,
    });

    const message = error.message;

    if (message === "NotAuthorized") {
      toast.error("Please login from extension and the reload this page");
      localStorage.removeItem("_gm_usr");
      window.location.reload();
    } else if (error.response.status === 401) {
      toast.error("Autorization failed, please re-login to the extension");
    } else {
      toast.error(message);
    }
  }
};

export const updateDeclineReasons =
  (declineReasons) => async (dispatch, getState) => {
    try {
      dispatch({
        type: SAVE_DECLINE_REASON_REQ,
      });

      const {
        userLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo.gmBackendToken}`,
        },
      };

      const { data } = await api.post(`/api/decline-reasons`, declineReasons, config);
      toast.success(data?.message || "Decline reasons updated successfully");

      dispatch({
        type: SAVE_DECLINE_REASON_SUCCESS,
        payload: data?.body,
      });
    } catch (error) {
      const message = error.message;

      dispatch({
        type: SAVE_DECLINE_REASON_FAIL,
        payload: message,
      });
      if (message === "NotAuthorized") {
        toast.error("Please login from extension and the reload this page");
        localStorage.removeItem("_gm_usr");
        window.location.reload();
      } else if (error.response.status === 401) {
        toast.error("Autorization failed, please re-login to the extension");
      } else {
        toast.error(message);
      }
    }
  };

